// 问董秘
// 概念、互动、关键词 top 10
import request from '@/utils/request'
import { tokenurl, f10url, getwayurl, searchurl, sectorrelationurl,auth } from './config'
// import { logicalExpression } from '@babel/types';
type dataType = any
export default {
  getToken(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: tokenurl,
      method: 'post',
      data: auth,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  getInfoSecretaryTop(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/InfoSecretaryTop',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  gethotSearchV2(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: getwayurl + '/rjhy-gmg-quote/api/1/stock/hotSearchV2',
      method: 'get',
      params: data
    })
  },
  // 搜索
  getInfoSecretarySearch(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/InfoSecretarySearch',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  getgroupall(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: getwayurl+'/rjhy-optional/api/1/jfztpc/new/pc/group/all',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 加自选
  addStock(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: getwayurl+'/rjhy-optional/api/1/jfztpc/new/stock/add',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 删除自选
  deleteStock(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: getwayurl+'/rjhy-optional/api/1/jfztpc/new/stock/delete',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 搜索个股
  searchStock(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: searchurl + '/v2/search',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 个股相关股票
  getRela(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/InfoSecretaryRelationRank',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 个股所属板块
  getSectorlist(data: dataType): Promise<{
    response?: Response
  }> {
    return request({ // /sectorlistApi
      url: sectorrelationurl + '/sectorrelation/querysectorlist/',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  getInfoSecretaryIdRank(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/InfoSecretaryIdRank',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  }
}
